
export class SaveCatalogProductDto{

    public products: SaveProductDto[];
}

export class SaveProductDto{

    public productInventoryId: number;

    public points: number;

    public isSuggested: boolean;

    public categoryId : number;

    public noStock: boolean;

    public campaignProductId?: number;
}
